import api from '@/services/api/api';

const initialState = () => ({
  rating: null
});

const formHeaders = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };

export default {
  namespaced: true,
  state: initialState,
  getters: {
    rating: (state) => state.rating
  },
  mutations: {
    SET_RATING(state, rating) {
      state.rating = Array.isArray(rating) ? {} : rating;
    }
  },
  actions: {
    async isRated({ commit, state }, args) {
      const params = {
        calendar_id: args.calendar_id,
        class_number: args.class_number,
      }

      const { data } = await api.get('/course/calendar/class/summary/rate', { params });
      commit('SET_RATING', data);
      return data;
    },
    async rate({ commit, state }, payload) {
      try {
        await api.post('/course/calendar/class/summary/rate', payload, formHeaders);

        commit('SET_RATING', {
          calendar_id: Number(payload.get('calendar_id')),
          class_id: Number(payload.get('class_id')),
          qualification: Number(payload.get('qualification')),
          comment: payload.get('comment'),
        });
      } catch (error) {
        throw error;
      }
    }
  },
};
